import { useGlobalShortcuts, useWatchfaceSave } from '.';
import { ref } from 'vue';
import { useSnapshot } from './use-snapshot';
import { useEmitterListener } from './use-event-listener';
import { Shape } from '@/services/shape';
import { EventType } from '@/utils/emitter.utils';
import { useEditorStore } from '@/store/use-editor-store';

export const useEditorSnapshot = () => {
  const { record, clear, undo, redo } = useSnapshot();
  const { saveWatchfaceData } = useWatchfaceSave();
  const editorStore = useEditorStore();
  const init = ref(false);
  // 注册全局快捷键
  useGlobalShortcuts(
    [
      // 撤销
      {
        keyboardKeys: ['CommandOrControl', 'Z'],
        handler: async () => {
          await undo();
        }
      },
      // 恢复
      {
        keyboardKeys: ['CommandOrControl', 'Shift', 'Z'],
        handler: async () => {
          await redo();
        }
      },
      // 保存
      {
        keyboardKeys: ['CommandOrControl', 'S'],
        handler: async () => {
          await saveWatchfaceData();
        }
      }
    ],
    () => {
      return init.value;
    }
  );

  // snapshot
  useEmitterListener([EventType['watchface:opened-resources']], async () => {
    await clear();
    record();
    init.value = true;
  });
  const snapshotKey = ref(0);
  useEmitterListener(EventType['snapshot:restore'], () => {
    Shape.clearCache();
    snapshotKey.value = Math.random();
    // 重置当前选择的元素
    editorStore.activeShapes = editorStore.selectedIds.map((id) =>
      Shape.getShape(id)
    );
  });

  // 当图片数据变动时
  useEmitterListener(
    [
      // 当layer数据变动
      EventType['shape:create'],
      EventType['shape:deleted'],
      EventType['shape:set-attr'],
      EventType['shape:drag'],
      EventType['shape:sloted'],
      EventType['shape:unsloted'],
      EventType['shape:widgeted'],
      EventType['shape:unwidgeted'],

      // 当theme数据变动时
      EventType['theme:create'],
      EventType['theme:move'],
      EventType['theme:delete'],
      EventType['theme:set-attr']
    ],
    async () => {
      if (init.value) record();
    }
  );

  return { snapshotKey };
};
